import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Lock, Diamond, Mail, Eye, EyeOff } from 'lucide-react';

const AdminLogin = () => {
  const { adminLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = adminLogin(email, password);
    if (result.success) navigate('/admin');
    else setError(result.error);
  };

  const inputCls = "w-full bg-[#111] border border-gray-800 rounded-lg px-4 py-3 text-white text-sm placeholder:text-gray-600 focus:outline-none focus:border-[#2EC866]/50 transition-colors";

  return (
    <div className="bg-[#0a0a0a] min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-[#111] border border-gray-800/50 rounded-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#2EC866]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Diamond className="w-8 h-8 text-[#2EC866]" />
            </div>
            <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              Admin Panel
            </h1>
            <p className="text-gray-500 text-xs mt-2">Luxo-Market Back Office</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-gray-400 text-xs mb-1.5 block">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@passlux.com"
                  required
                  className={`${inputCls} pl-10`}
                />
              </div>
            </div>
            <div>
              <label className="text-gray-400 text-xs mb-1.5 block">Password</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-600" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  className={`${inputCls} pl-10 pr-10`}
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600 hover:text-gray-400"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            {error && <p className="text-red-400 text-sm">{error}</p>}

            <button type="submit"
              className="w-full bg-[#2EC866] hover:bg-[#25a855] text-white font-semibold py-3.5 rounded-lg transition-all duration-300"
            >
              Sign In
            </button>
          </form>

          <p className="text-gray-600 text-[10px] text-center mt-6">
            Default: admin@luxo-market.com / admin123
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
